import { useMediaQuery } from 'react-responsive';

export const breakPoints: {
  sm: string;
  md: string;
  lg: string;
  xl: string;
  '2xl': string;
} = {
  sm: '480px',
  md: '768px',
  lg: '976px',
  xl: '1100px',
  '2xl': '1440px',
};

type BreakpointKey = keyof typeof breakPoints;

export default function useBreakPoints<K extends BreakpointKey>(
  breakPointKey: K,
) {
  const bool = useMediaQuery({
    minWidth: `${breakPoints[breakPointKey]}`,
  });

  const capitalizedKey =
    breakPointKey.charAt(0).toUpperCase() + breakPointKey.substring(1);

  type Key = `is${Capitalize<K>}`;

  return {
    [`is${capitalizedKey}`]: bool,
  } as Record<Key, boolean>;
}
